import MiniappPicker from './miniapp-picker';
import H5Picker from './picker';
import { isMiniappPlatform } from '../utils';
import './styles/index.scss';
const Picker = isMiniappPlatform ? MiniappPicker : H5Picker;
Picker.displayName = 'Picker';
export default Picker;
